import KeepLink from './KeepLink';
import './Breadcrumb.css';

interface Props {
    history: number[];
}

export default function Breadcrumb({ history }: Props) {
    if (history.length <= 1) return null;
    return (
        <nav className="crumb" aria-label="Recent kurals">
            <ol className="crumb__list">
                {history.map((n, i) => {
                    const isLast = i === history.length - 1;
                    return (
                        <li key={`${n}-${i}`} className="crumb__item">
                            {isLast ? (
                                <span className="crumb__here" aria-current="page">
                                    Kural {n}
                                </span>
                            ) : (
                                <>
                                    <KeepLink to={`/kural/${n}`} className="crumb__link">
                                        Kural {n}
                                    </KeepLink>
                                    <span className="crumb__sep" aria-hidden="true">
                                        ›
                                    </span>
                                </>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
